// CSRF 防护（ESM 版）：为所有状态变更请求添加 X-Requested-With 头
// 后端 CSRF 中间件校验此头，缺失则拒绝请求
// 副作用模块：import 时立即 patch window.fetch

var originalFetch = window.fetch;
if (originalFetch && !originalFetch.__csrfPatched) {
  var patched = function(input, init) {
    init = init || {};
    var method = (init.method || 'GET').toUpperCase();
    if (method !== 'GET' && method !== 'HEAD' && method !== 'OPTIONS') {
      init.headers = Object.assign({}, init.headers || {}, { 'X-Requested-With': 'XMLHttpRequest' });
    }
    return originalFetch.call(this, input, init);
  };
  patched.__csrfPatched = true;
  window.fetch = patched;
}
